var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 729,
    height: 1684,
    viewBox: "0 0 729 1684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_2628)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -113,
    cy: 842,
    r: 452,
    fill: "url(#paint0_radial_27_2628)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_2628",
    x: -955,
    y: 0,
    width: 1684,
    height: 1684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 195,
    result: "effect1_foregroundBlur_27_2628"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_27_2628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-262.061 671.026) rotate(-29.4397) scale(347.856 1247.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGradient);
export default __webpack_public_path__ + "static/media/big-gradient.2161581ea012aae7064e42d656f1e7f9.svg";
export { ForwardRef as ReactComponent };